<script setup lang="ts">
// import { authService } from "./utils/api/authService";

useHead({
  title: "Projekt energetyczny",
});

// onBeforeMount(async () => {
//   if (!document.cookie.includes("XSRF-TOKEN")) {
//     await authService.getCsrf();
//   }
// });

useRouteMetaChild();
</script>

<template>
  <NuxtErrorBoundary>
    <div class="bg-primary">
      <NuxtLayout class="mx-auto font-inter 3xl:max-w-[1920px]">
        <NuxtPage />
        <DefaultToast position="bottom-right" />
      </NuxtLayout>
    </div>
  </NuxtErrorBoundary>
</template>
